import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const HeroSlideshow = ({ images, interval = 5000, children, testId = "hero-slideshow" }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div data-testid={testId} className="relative min-h-[100vh] w-full overflow-hidden flex items-center">
      <AnimatePresence mode="sync">
        <motion.div
          key={index}
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
        >
          <motion.img
            src={images[index]}
            alt="The Market Place, Jaipur — homegrown businesses in action"
            className="w-full h-full object-cover object-top"
            initial={{ scale: 1 }}
            animate={{ scale: 1.1 }}
            transition={{ duration: interval / 1000 + 1.2, ease: "linear" }}
          />
        </motion.div>
      </AnimatePresence>

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent" />

      <div className="relative z-10 w-full">{children}</div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-10" data-testid="hero-slideshow-dots">
        {images.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            data-testid={`hero-slide-dot-${i}`}
            aria-label={`Go to slide ${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? "w-8 bg-[#D81B60]" : "w-4 bg-white/50 hover:bg-white/80"}`}
          />
        ))}
      </div>
    </div>
  );
};
